var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.isLeft ? "floL" : "floR" },
    [
      _c(
        "p",
        {
          staticClass: "fntH6 fntL bold marTML marBM",
          staticStyle: { color: "#2c2c2c" },
          style: _vm.isLeft ? { width: "49%" } : null
        },
        [_vm._v(_vm._s(_vm.getFullTextByType(_vm.participant)))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "padBM NCAcmi_lineBtm",
          class: _vm.isLeft ? "NCAcmi_cont01-1" : "NCAcmi_cont01-2"
        },
        [
          _c("p", { staticClass: "fntP", class: { moOnly: !_vm.isLeft } }, [
            _vm._v("참여여부 "),
            _c("span", { staticClass: "ico-must-astar" })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "amway-theme", staticStyle: { width: "55%" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "action NCAcmi_radioBtn radio-wrapper NCAcmi_cont01_radio"
                },
                [
                  _c(
                    "label",
                    { staticClass: "amw-radio-wrap radio-label focus" },
                    [
                      _c("input", {
                        staticClass: "amw-global-radio",
                        attrs: {
                          type: "radio",
                          name: "attendance-radio-" + _vm.seq,
                          value: "Y",
                          disabled: !_vm.infoAvailable
                        },
                        domProps: {
                          checked: _vm.participant.attendance_yn === "Y"
                        },
                        on: { change: _vm.selectAttendance }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-radio-overlay" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-label-radio-text" }, [
                        _vm._v("참여")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "amw-radio-wrap radio-label focus" },
                    [
                      _c("input", {
                        staticClass: "amw-global-radio",
                        attrs: {
                          type: "radio",
                          name: "attendance-radio-" + _vm.seq,
                          value: "N",
                          disabled: !_vm.infoAvailable
                        },
                        domProps: {
                          checked: _vm.participant.attendance_yn === "N"
                        },
                        on: { change: _vm.selectAttendance }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-radio-overlay" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-label-radio-text" }, [
                        _vm._v("불참")
                      ])
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "padBSM padTSM NCAcmi_cont01_input NCAcmi_lineBtm",
          class: _vm.isLeft ? "NCAcmi_cont01-1" : "NCAcmi_cont01-2"
        },
        [
          _c(
            "label",
            {
              staticClass: "fntP",
              class: { moOnly: !_vm.isLeft },
              attrs: { for: "NCAcmi_name" + _vm.seq }
            },
            [_vm._v("이름 "), _c("span", { staticClass: "ico-must-astar" })]
          ),
          _vm._v(" "),
          _c("input", {
            attrs: {
              type: "text",
              id: "NCAcmi_name" + _vm.seq,
              name: "NCAcmi_name" + _vm.seq,
              disabled:
                _vm.disabledByType ||
                _vm.disabledByAttendance ||
                !_vm.infoAvailable,
              size: "50",
              maxlength: "50"
            },
            domProps: { value: _vm.participant.name },
            on: {
              input: function($event) {
                return _vm.inputName(_vm.seq, $event.target.value)
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "padBSM padTSM NCAcmi_lineBtm",
          class: _vm.isLeft
            ? "NCAcmi_cont01-1 NCAcmi_cont01_input"
            : "NCAcmi_cont01-2 NCAcmi_pc"
        },
        [
          _vm.isLeft
            ? [
                _c(
                  "label",
                  {
                    staticClass: "fntP",
                    attrs: { for: "NCAcmi_abo" + _vm.seq }
                  },
                  [_vm._v("ABO번호")]
                ),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    type: "text",
                    id: "NCAcmi_abo" + _vm.seq,
                    name: "NCAcmi_abo" + _vm.seq,
                    disabled: ""
                  },
                  domProps: { value: _vm.participant.abo_uid }
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "padBSM padTSM NCAcmi_lineBtm",
          class: _vm.isLeft ? "NCAcmi_cont01-1" : "NCAcmi_cont01-2"
        },
        [
          _c(
            "label",
            {
              staticClass: "fntP",
              class: { moOnly: !_vm.isLeft },
              staticStyle: { width: "45%" },
              attrs: { for: "NCAcmi_personal01-" + _vm.seq }
            },
            [
              _vm._v("주민등록번호 "),
              _c("span", { staticClass: "ico-must-astar" })
            ]
          ),
          _vm._v(" "),
          _c("em", { staticClass: "txtR", staticStyle: { width: "55%" } }, [
            _c("input", {
              staticClass: "NCAcmi_num",
              staticStyle: { width: "45%" },
              attrs: {
                type: "number",
                id: "NCAcmi_personal" + _vm.seq + "-1",
                name: "NCAcmi_personal" + _vm.seq + "-1",
                maxlength: "6",
                disabled: _vm.disabledByAttendance || !_vm.infoAvailable
              },
              domProps: { value: _vm.participant.questions["Q014_1"].raw_data },
              on: {
                input: function($event) {
                  return _vm.inputJuminNumber(_vm.seq, "Q014_1", $event.target)
                }
              }
            }),
            _c(
              "span",
              { staticClass: "disIb txtC", staticStyle: { width: "10%" } },
              [_vm._v("-")]
            ),
            _c("input", {
              staticClass: "NCAcmi_num",
              staticStyle: { width: "45%", "-webkit-text-security": "disc" },
              attrs: {
                type: "number",
                id: "NCAcmi_personal" + _vm.seq + "-2",
                name: "NCAcmi_personal" + _vm.seq + "-2",
                maxlength: "7",
                disabled: _vm.disabledByAttendance || !_vm.infoAvailable
              },
              domProps: { value: _vm.participant.questions["Q014_2"].raw_data },
              on: {
                input: function($event) {
                  return _vm.inputJuminNumber(_vm.seq, "Q014_2", $event.target)
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _vm.existSpouse
        ? _c("SurveyAttachment", {
            staticClass: "padBSM padTSM NCAcmi_lineBtm",
            class: { NCAcmi_blankR: _vm.participant.type !== "S" },
            attrs: {
              participant: _vm.participant,
              "sq-code": "Q013",
              disabled: _vm.disabledByAttendance || !_vm.infoAvailable,
              "hide-btn": _vm.participant.type !== "S",
              "is-left": _vm.isLeft
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("SurveyAttachment", {
        staticClass: "padBSM padTSM NCAcmi_file02-1_wrap",
        class: {
          NCAcmi_last:
            _vm.participant.type === "S" ||
            (_vm.participant.type === "P" && _vm.hideDocument)
        },
        attrs: {
          participant: _vm.participant,
          "sq-code": "Q015",
          disabled: _vm.disabledByAttendance || !_vm.infoAvailable,
          "is-left": _vm.isLeft
        }
      }),
      _vm._v(" "),
      _vm.needFamilyRelationDocument
        ? _c("SurveyAttachmentCommon", {
            staticClass: "padBSM padTSM NCAcmi_lineBtm",
            class: { NCAcmi_blankR: _vm.hideDocument },
            attrs: {
              "sq-code": "Q012",
              disabled: _vm.disabledByAttendance || !_vm.infoAvailable,
              "is-left": _vm.isLeft,
              "hide-btn": _vm.hideDocument,
              height: !_vm.isLeft && _vm.hideDocument ? "198.19px" : null
            },
            scopedSlots: _vm._u(
              [
                _vm.hideDocument && _vm.isLeft
                  ? {
                      key: "inner",
                      fn: function() {
                        return [
                          _c("span", {
                            staticClass: "fntE pcOnly disBl",
                            staticStyle: {
                              color: "#d91734",
                              "padding-left": "0.6em"
                            },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.questions["Q012"].alert_text
                              )
                            }
                          })
                        ]
                      },
                      proxy: true
                    }
                  : null,
                {
                  key: "outer",
                  fn: function() {
                    return [
                      !_vm.hideDocument && _vm.isLeft
                        ? _c("p", {
                            staticClass: "marTS fntE",
                            staticStyle: {
                              color: "#d91734",
                              "padding-left": "0.6em"
                            },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.questions["Q012"].alert_text
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.hideDocument && !_vm.isLeft
                        ? _c("p", {
                            staticClass: "marTS moOnly fntE",
                            staticStyle: {
                              color: "#d91734",
                              "padding-left": "0.6em"
                            },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.questions["Q012"].alert_text
                              )
                            }
                          })
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c("SurveyAttachmentCommon", {
        staticClass: "padBSM padTSM NCAcmi_lineBtm",
        class: { NCAcmi_blankR: _vm.hideDocument },
        attrs: {
          "sq-code": "Q016",
          disabled: _vm.disabledByAttendance || !_vm.infoAvailable,
          "is-left": _vm.isLeft,
          "hide-btn": _vm.hideDocument
        }
      }),
      _vm._v(" "),
      _c("SurveyAttachmentCommon", {
        staticClass: "padBSM padTSM",
        class: {
          NCAcmi_blankR: _vm.hideDocument,
          "NCAcmi_file02-1_wrap": _vm.needFamilyDocument
        },
        attrs: {
          "sq-code": "Q017",
          disabled: _vm.disabledByAttendance || !_vm.infoAvailable,
          "is-left": _vm.isLeft,
          "hide-btn": _vm.hideDocument
        }
      }),
      _vm._v(" "),
      _vm.needFamilyDocument
        ? _c("SurveyAttachmentCommon", {
            staticClass: "padBSM padTSM",
            class: _vm.hideDocument ? "NCAcmi_cont01-2 NCAcmi_pc" : null,
            style:
              _vm.participant.type === "P" &&
              _vm.participant.type_seq === 1 &&
              _vm.hideDocument
                ? { "justify-content": "flex-start" }
                : null,
            attrs: {
              "sq-code": "Q018",
              disabled: _vm.disabledByAttendance || !_vm.infoAvailable,
              "is-left": _vm.isLeft,
              "hide-btn": _vm.hideDocument
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c198a5e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c198a5e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey2/components/SurveyParticipant.vue
// module id = null
// module chunks = 